import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
} from "@mui/material";
import React from "react";
import { useGrapeList } from "./context/GrapeListProvider";

export const DeleteProductDialog = () => {
	const {
		removeDialogOpen,
		selectedProduct,
		confirmRemoveProduct,
		cancelRemoveProduct,
	} = useGrapeList();
	return (
		<Dialog
			PaperProps={{
				sx: {
					// width: 900,
					p: 2,
					// maxWidth: "95vw",
				},
			}}
			open={removeDialogOpen}
			onClose={cancelRemoveProduct}
		>
			<DialogTitle>Remove Product</DialogTitle>

			<DialogContent>
				<DialogContentText>
					Are you sure you want to remove{" "}
					<strong>{selectedProduct?.name}</strong>?
				</DialogContentText>
			</DialogContent>

			<DialogActions>
				<Button onClick={cancelRemoveProduct}>Cancel</Button>

				<Button
					color="error"
					variant="contained"
					onClick={confirmRemoveProduct}
				>
					Remove
				</Button>
			</DialogActions>
		</Dialog>
	);
};
